import React from 'react';
import { colors } from 'seedling/constants';

const GridIcon = ({ color }) => (
  <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1">
    <defs>
      <rect id="path-1" x="0" y="0" width="4.875" height="4.875" />
      <mask
        id="mask-2"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="4.875"
        height="4.875"
        fill={color}
      >
        <use xlinkHref="#path-1" />
      </mask>
      <rect id="path-3" x="8.125" y="0" width="4.875" height="4.875" />
      <mask
        id="mask-4"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="4.875"
        height="4.875"
        fill={color}
      >
        <use xlinkHref="#path-3" />
      </mask>
      <rect id="path-5" x="0" y="8.125" width="4.875" height="4.875" />
      <mask
        id="mask-6"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="4.875"
        height="4.875"
        fill={color}
      >
        <use xlinkHref="#path-5" />
      </mask>
      <rect id="path-7" x="8.125" y="8.125" width="4.875" height="4.875" />
      <mask
        id="mask-8"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="4.875"
        height="4.875"
        fill={color}
      >
        <use xlinkHref="#path-7" />
      </mask>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Integrations-Grid"
        transform="translate(-1260.000000, -112.000000)"
        stroke={color}
      >
        <g id="Group" transform="translate(1221.000000, 112.000000)">
          <g id="Grid-Icon" transform="translate(39.000000, 0.000000)">
            <g id="Rectangle-4">
              <use mask="url(#mask-2)" strokeWidth="2" xlinkHref="#path-1" />
              <use mask="url(#mask-4)" strokeWidth="2" xlinkHref="#path-3" />
              <use mask="url(#mask-6)" strokeWidth="2" xlinkHref="#path-5" />
              <use mask="url(#mask-8)" strokeWidth="2" xlinkHref="#path-7" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

GridIcon.defaultProps = {
  color: colors.darkestGrey,
};

export default GridIcon;
